/* eslint-disable import/no-unresolved */
import React, { useState, useEffect, Fragment } from "react";
import { connect, useDispatch } from "react-redux";
import InvoiceList from "./InvoiceList";
import InvoiceDetailView from "./InvoiceDetailSection";
import InvoicesTotals from "./InvoicesTotals";
import { push } from "../../utils/navigation";
import { BASE_URL, INVOICE_EXPORT_STATUS_IDS } from "../../constants";
import { cancelInvoice, deleteInvoice, downloadExportedInvoice, getInvoiceDetails } from "../../actions/myobActions";
import { toastr } from "react-redux-toastr";
import { isAxiosError } from "axios";
import { mustBeArray } from "../../utils";

const MYOBDetailView = ({
  params,
}) => {
  const [details, setDetails] = useState(null);
  const [retrieving, setRetrieving] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isCancelling, setIsCancelling] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    getDetails();
  }, []);

  const onDownload = async () => {
    setDownloading(true);
    try {
      await downloadExportedInvoice(params.id);
    } catch (error) {
      if(isAxiosError(error)) {
        if(error.response.data instanceof Blob && error.response.status === 400) {
          const errorJson = await error.response.data.text();
          const failure = JSON.parse(errorJson);
          failure.errors.forEach(fail => {
            toastr.error(fail.message);
          });
        } else {
          toastr.error("Could not download Invoice Report");
        }
      }
    } finally {
      setDownloading(false);
    }
  };

  const getDetails = async () => {
    try {
      setRetrieving(true);
      const details = await getInvoiceDetails(params.id);
      setDetails(details);
    } catch (error) {
      if(isAxiosError(error))
      {
        if(error.response.status === 404) {
          toastr.info("Not found", "Specified Invoice does not exist");
          dispatch(push(`${BASE_URL}/invoice`));
        }
      }
    } finally {
      setRetrieving(false);
    }
  };

  const onDelete = async () => {
    try {
      setIsDeleting(true);
      await deleteInvoice(params.id);
      toastr.success("Deleted Invoice");
      dispatch(push(`${BASE_URL}/invoice`));
    } catch (error) {
      toastr.error("Failed to delete invoice");
    } finally {
      setIsDeleting(false);
    }
  }

  const onCancel = async () => {
    try {
      setIsCancelling(true);
      await cancelInvoice(params.id);
      toastr.success("Cancelled Invoice");
      dispatch(push(`${BASE_URL}/invoice`));
    } catch (error) {
      toastr.error("Failed to cancel invoice. Please try again");
      if(isAxiosError(error)){
        if(error.response.data.Errors){
          mustBeArray(error.response.data.Errors).forEach(e => {
            toastr.error(e.Message || "");
          });
        }
      }
    } finally {
      setIsCancelling(false);
    }
  };

  const onDismiss = () => {
    dispatch(push(`${BASE_URL}/invoice`));
  };

  return (
    <React.Fragment>
      <div className={"row"}>
        <div className={"col-12"} style={{ marginBottom: "24px" }}>
          <h4>View Invoice</h4>
        </div>
      </div>
      {retrieving && (
        <div>Loading Invoice...</div>
      )}
      {!retrieving && details && (
        <Fragment>
          <InvoiceDetailView details={details} />
          <InvoiceList
            detailView={true}
            rows={details.lines}
          />
          <div className="mt-2 full-width">
            <InvoicesTotals
              total={details.total}
              totalExGst={details.totalExGst}
              gstAmount={details.gstAmount}
            />
          </div>
          <div className="mt-2">
            {details.canDownloadReport && (
              <button
                className={`btn btn-primary`}
                onClick={onDownload}
                disabled={downloading}
              >
                <i className="fa fa-arrow-down" aria-hidden="true"></i> &nbsp;
                {downloading ? "Downloading" : "Download Invoice"}
              </button>
            )}
            <button className="btn btn-default ml-1" onClick={onDismiss}>
              <i className="fa fa-arrow-left" aria-hidden="true"></i> &nbsp;Back
            </button>

            {details.exportStatusId === INVOICE_EXPORT_STATUS_IDS.Exported && (
              <button
                className={`btn btn-default ml-1 bold float-right`}
                onClick={onCancel}
                disabled={isDeleting || isCancelling}
              >
                <i className="fa fa-times" aria-hidden="true"></i> &nbsp;
                {isCancelling ? "Cancelling" : "Cancel Invoice"}
              </button>
            )}

            {!details.canDownloadReport && details.exportStatusId !== INVOICE_EXPORT_STATUS_IDS.Exported && (
              <button
                className={`btn btn-danger ml-1 bold float-right`}
                onClick={onDelete}
                disabled={isDeleting || isCancelling}
              >
                <i className="fa fa-trash-o" aria-hidden="true"></i> &nbsp;
                {isDeleting ? "Deleting" : "Delete Invoice"}
              </button>
            )}
          </div>
        </Fragment>
      )}
    </React.Fragment>
  );
};

export default MYOBDetailView;

